module.exports = __webpack_public_path__ + "static/img/tomatoes.280f314.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/tomatoes.svg
// module id = XLDM
// module chunks = 1